(() => {
  const initialise = () => {
    document.querySelectorAll('.yrp-header-search').forEach(search => {
      if (search.dataset.bound) return;
      search.dataset.bound = 'true';
      const trigger = search.querySelector(':scope > summary');
      const input = search.querySelector('input[type="search"]');
      const header = search.closest('.yrp-banner-header,.header');
      const panel = search.querySelector('.yrp-header-search__panel');
      const mobile = window.matchMedia('(min-width: 0px)');
      const updatePosition = () => {
        if (!header || !search.open || !mobile.matches) return;
        const bottom = Math.max(0, header.getBoundingClientRect().bottom);
        search.style.setProperty('--yrp-search-mobile-top', bottom + 'px');
        search.style.setProperty('--yrp-search-mobile-height', Math.max(56, (window.visualViewport?.height || window.innerHeight) - bottom) + 'px');
      };
      const syncMobile = () => {
        const active = mobile.matches && search.open;
        if (active) panel.setAttribute('aria-modal', 'true');
        else panel.removeAttribute('aria-modal');
        updatePosition();
        document.body.classList.toggle('yrp-mobile-search-open', mobile.matches && Boolean(document.querySelector('.yrp-header-search[open]')));
      };
      const close = restoreFocus => {
        search.open = false;
        syncMobile();
        trigger.setAttribute('aria-expanded','false');
        if (restoreFocus) trigger.focus();
      };
      trigger.setAttribute('aria-expanded',String(search.open));
      search.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded',String(search.open));
        syncMobile();
        if (!search.open) return;
        if (header) header.querySelectorAll('.yrp-header-links__item[open],.yrp-site-nav[open]').forEach(menu => { menu.open = false; });
        input.focus({preventScroll:true});
      });
      search.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', () => close(true)));
      mobile.addEventListener('change', syncMobile);
      window.addEventListener('resize', updatePosition);
      window.visualViewport?.addEventListener('resize', updatePosition);
      search.addEventListener('keydown', event => {
        if (event.key === 'Tab' && search.open && mobile.matches) {
          const focusable = [...panel.querySelectorAll('input:not([type="hidden"]),button,a[href]')].filter(element => element.getClientRects().length && !element.disabled);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
          return;
        }
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        close(true);
      });
      const results = search.querySelector('[data-search-live-results]');
      const status = search.querySelector('[data-search-live-status]');
      const form = search.querySelector('form');
      const cache = new Map();
      let timer, controller, version = 0;
      const clearResults = () => {
        version++;
        clearTimeout(timer);
        controller?.abort();
        results.hidden = true;
        results.replaceChildren();
        results.removeAttribute('aria-busy');
        status.textContent = '';
        search.classList.remove('yrp-header-search--has-query');
      };
      const allResultsLink = term => {
        const link = document.createElement('a');
        const url = new URL(form.action, location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        link.className = 'yrp-header-search__view-all';
        link.href = url.toString();
        link.textContent = search.dataset.viewAllLabel;
        return link;
      };
      const loadResults = async () => {
        const term = input.value.trim();
        if (!term || !mobile.matches || !search.open) {
          clearResults();
          return;
        }
        const requestVersion = ++version;
        controller?.abort();
        controller = new AbortController();
        search.classList.add('yrp-header-search--has-query');
        results.hidden = false;
        results.setAttribute('aria-busy', 'true');
        status.textContent = search.dataset.loadingLabel;
        updatePosition();
        try {
          let markup = cache.get(term);
          if (!markup) {
            const url = new URL(search.dataset.predictiveUrl, location.origin);
            url.searchParams.set('q', term);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '4');
            url.searchParams.set('resources[options][fields]', 'title,product_type,vendor,variants.title');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            url.searchParams.set('section_id', 'yrp-header-search-results');
            const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
            if (!response.ok) throw new Error('Search preview unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = doc.querySelector('[data-header-search-results]');
            if (!content) throw new Error('Search preview missing');
            markup = content.innerHTML;
            cache.set(term, markup);
          }
          if (requestVersion !== version || term !== input.value.trim() || !search.open || !mobile.matches) return;
          results.innerHTML = markup;
          status.textContent = results.querySelector('[data-header-search-status]')?.textContent || '';
        } catch (error) {
          if (error.name === 'AbortError' || requestVersion !== version) return;
          results.replaceChildren(allResultsLink(term));
          status.textContent = '';
        } finally {
          if (requestVersion === version) results.removeAttribute('aria-busy');
        }
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        version++;
        controller?.abort();
        if (!input.value.trim() || !mobile.matches) {
          clearResults();
          return;
        }
        results.hidden = true;
        results.replaceChildren();
        timer = setTimeout(loadResults, 180);
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && !results.hidden) {
          const first = results.querySelector('a[href]');
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
      results.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const links = [...results.querySelectorAll('a[href]')];
        const index = links.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        if (event.key === 'ArrowUp' && index === 0) input.focus();
        else links[Math.max(0, Math.min(links.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
      });
      search.addEventListener('toggle', () => {
        if (search.open && mobile.matches && input.value.trim()) loadResults();
        else if (!search.open) clearResults();
      });
      mobile.addEventListener('change', () => {
        if (!mobile.matches) clearResults();
        else if (search.open && input.value.trim()) loadResults();
      });
      document.addEventListener('click', event => {
        if (search.open && !search.contains(event.target)) close(false);
      });
      document.addEventListener('toggle', event => {
        if (search.open && header && event.target !== search && header.contains(event.target) && event.target.matches('.yrp-header-links__item[open],.yrp-site-nav[open]')) close(false);
      },true);
    });
  };
  initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
